import {Button} from "@/components/ui/button";

interface ContraintesResetButtonProps {
  onClick: () => void;
}

const ContraintesResetButton = (props: ContraintesResetButtonProps) => {
  const { onClick } = props;
  return (
    <li className="list-group-item">
      <span>
        <Button
          type="button"
          id="reset_contraintes"
          variant="secondary"
          size="sm"
          onClick={onClick}
        >
          Remise à zéro filtres
        </Button>
      </span>
    </li>
  );
};

export default ContraintesResetButton;
